import React from "react";

import Grid from "../../components/lib/Grid";
import User from "./User";

import type { SearchAllocatorUserDataObject } from "./types";

type Props = {
  users: SearchAllocatorUserDataObject[];
};

export default function (props: Props) {
  const { users } = props;

  const usersRender = users.map((user: SearchAllocatorUserDataObject) => (
    <User key={user["id"]} user={user} />
  ));

  return (
    <Grid
      fill
      css={{
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        "@md": {
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        "@lg": {
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        },
        color: "$secondary",
        gap: "$5",
        justifyContent: "center",
        justifyItems: "stretch",
        padding: "$1",
      }}
    >
      {usersRender}
    </Grid>
  );
}
